import { render } from "./OrderSubmission.vue?vue&type=template&id=55fc6c39&scoped=true"
import script from "./OrderSubmission.vue?vue&type=script&lang=js"
export * from "./OrderSubmission.vue?vue&type=script&lang=js"

import "./OrderSubmission.vue?vue&type=style&index=0&id=55fc6c39&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55fc6c39"]])

export default __exports__